import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import TabBar from "@/components/tab-bar/tab-bar";
import * as editorActions from "@/lib/state/actions//editor-actions";
import * as animationActions from "@/lib/state/actions/animation-actions";
import { EditorFramePickerMode } from "@/lib/state/reducers/editor-reducer";
import { animationSelector } from "@/lib/state/selectors/animation-selector";
import { editorSelector } from "@/lib/state/selectors/editor-selector";
import { framePickerSelector } from "@/lib/state/selectors/frame-picker-selector";
import { useAppDispatch } from "@/lib/state/store";

import TimelineFrame from "../timeline/timeline-frame";

import LayerPicker from "./layer-picker";

export const FramePickerInner = () => {
  const dispatch = useAppDispatch();
  const { width, height } = useSelector(animationSelector);
  const uniqueSequenceItems = useSelector(framePickerSelector);

  const {
    currentLayerIndex,
    framePickerMode,
    currentFrameIndex,
    framePickerLayerMode,
  } = useSelector(editorSelector);

  const onFrameSelected = (sourceFrameId: string) => {
    dispatch(editorActions.undoStackPush());

    const sourceFrameIndex = uniqueSequenceItems.find(
      (f) => f.id === sourceFrameId,
    )?.index;

    if (sourceFrameIndex === undefined) return;

    if (framePickerMode === "insert") {
      dispatch(
        animationActions.addFromFrame(
          sourceFrameIndex,
          currentFrameIndex + 1,
          framePickerLayerMode,
        ),
      );
      dispatch(editorActions.goToFrame(currentFrameIndex + 1));
    } else if (framePickerMode === "overwrite") {
      dispatch(
        animationActions.replaceFrame(
          sourceFrameIndex,
          currentFrameIndex,
          framePickerLayerMode,
        ),
      );
    } else if (framePickerMode === "overwrite-all") {
      dispatch(
        animationActions.replaceAllFrames(
          sourceFrameIndex,
          framePickerLayerMode,
        ),
      );
    }
  };

  const frames = uniqueSequenceItems.map((sequenceItem) => {
    return (
      <TimelineFrame
        layers={sequenceItem.layers}
        index={sequenceItem.index + 1}
        key={`${sequenceItem.id}-${sequenceItem.index}`}
        id={sequenceItem.id}
        onFrameSelected={onFrameSelected}
        width={width}
        height={height}
        showCounter={true}
      />
    );
  });

  return (
    <Fragment>
      <button
        className="framepicker-close"
        onClick={() => dispatch(editorActions.toggleFramePicker())}
      >
        <FontAwesomeIcon icon={faTimesCircle} />
      </button>
      <TabBar
        selected={framePickerMode}
        onChange={(mode) => {
          dispatch(
            editorActions.setFramePickerMode(mode as EditorFramePickerMode),
          );
        }}
        options={[
          { id: "insert", value: "insert", label: "Copy to new" },
          { id: "overwrite", value: "overwrite", label: "Replace" },
          {
            id: "overwrite-all",
            value: "overwrite-all",
            label: "Replace whole layer",
          },
        ]}
      />

      <LayerPicker />

      <p className="p-4">
        Choose frames to copy (duplicated frames are hidden)
      </p>
      <ol className="framepicker-list overflow-y-scroll">{frames}</ol>
    </Fragment>
  );
};
